import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';


const OrderAddressInformation = ({order}) => {
  const {
    billing_address: {
      firstname,
      lastname,
      city,
      postcode,
      region,
      street,
      telephone,
      country_id
    },
    extension_attributes: {
      shipping_assignments
    }
  } = order;
  const [{shipping}] = shipping_assignments;

  return (
    <TableContainer>
      <Table className="inheritTable">
        <TableHead>
          <TableRow>
            <TableCell width="10%" />
            <TableCell>Billing Address</TableCell>
            <TableCell width="10%" />
            <TableCell>Shipping Address</TableCell>
            <TableCell width="10%" />
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell width="10%" />
            <TableCell>
              <div className="flex-column pr-10">
                <span>{firstname} {lastname}</span>
                {street.map((line, idx) => <span key={`address-line-${idx}`}>{line}</span>)}
                <span>{city}, {region} {postcode}</span>
                <span>{country_id === 'US' ? 'United States' : ''}</span>
                <span>T: {telephone}</span>
              </div>
            </TableCell>
            <TableCell width="10%" />
            <TableCell className="align-top">
              <div className="flex-column pr-10">
                <span>{shipping?.address?.firstname} {shipping?.address?.lastname}</span>
                {shipping?.address?.street.map((line, idx) => <span key={`address-line-${idx}`}>{line}</span>)}
                <span>
                  {shipping?.address?.city ? `${shipping?.address?.city}, ` : ''}
                  {shipping?.address?.region}{' '}
                  {shipping?.address?.postcode}
                </span>
                <span>{shipping?.address?.country_id === 'US' ? 'United States' : ''}</span>
                <span>{shipping?.address?.telephone && 'T: '}{shipping?.address?.telephone}</span>
              </div>
            </TableCell>
            <TableCell width="10%" />
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OrderAddressInformation;
